import React from 'react'
import SvgKey from './svgKey'
import AmortImage from '../../static/amort.png'
import {lifecycle} from 'recompose'
import {percentageSeen} from "../utils"

const amortHeight = 400
const id = "less-than-600"

const LessThan600 = () => (
  <div style={{ position: 'relative' }}>
    <img id="LessThan600" src={AmortImage} height={`${amortHeight}px`} />
    <SvgKey
      id={id}
      transition={true}
      height={400}
      cardX={0}
      cardY={295}
      whaleX={103}
      whaleY={275}
      svgKeyWidth={300}
      svgKeyHeight={200}
      whaleWidth={55}
      whaleHeight={28}
      maskHeight={60}
      style={{
        position: 'absolute',
        top: 0,
        left: 80,
        width: '80%'
      }}
    />
  </div>
)

export default lifecycle({
  componentDidMount() {
    let prevOnScroll = () => {}
    if (typeof window.onscroll === "function") {
      prevOnScroll = window.onscroll.bind({})
    }
    window.onscroll = function() {
      prevOnScroll()
      const amortImg = document.getElementById("LessThan600")
      const percentage = percentageSeen(amortImg, amortHeight)
      const glassrect = document.getElementById(`${id}glassrect`)
      const svgkey = document.getElementById(`${id}svgkey`)
      if (percentage < 50) {
        if (glassrect) {
          glassrect.setAttribute('y', 30)
        }
        if (svgkey) {
          svgkey.setAttribute('y', 0)
        }
      } else if (percentage == 100) {
        if (glassrect) {
          glassrect.setAttribute('y', 255)
        }
        if (svgkey) {
          svgkey.setAttribute('y', 225)
        }
      } else {
        if (glassrect) {
          glassrect.setAttribute('y', 225/50*(percentage-50) + 30)
        }
        if (svgkey) {
          svgkey.setAttribute('y', 225/50*(percentage-50))
        }
      }
    }
  }
})(LessThan600)



// WEBPACK FOOTER //
// ./src/finwhale/amort/LessThan600.js